import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as XLSX from 'xlsx';
import { Box, Button } from '@mui/material';
import { importPOSOrderTemplate, importPOSOrderTemplateClear } from 'actions/EntityActions';
import ConfirmPOSOrderImportDialog from './ConfirmPOSOrderImportDialog';

class ExcelUploadPOSOrder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmDialog: false,
            model: {}
        };
    }

    callback = (model) => {
        this.setState({ model: model, confirmDialog: true });
    }

    uploadFile = (e, callback) => {
        e.preventDefault();
        let reader = new FileReader();
        let BranchId = this.props.branchId;
        let OrderId = this.props.currentOrder ? this.props.currentOrder.id : 0;
        let EmployeeId = this.props.employeeId;
        let PatientId = 0;
        let DeviceId = this.props.deviceData.id;
        reader.readAsArrayBuffer(e.target.files[0]);
        reader.onload = function (e) {
            let data = new Uint8Array(reader.result);
            let wb = XLSX.read(data, { type: 'array' });

            let sheetName = wb.SheetNames[0];
            let worksheet = wb.Sheets[sheetName];
            let json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            let itemsArray = [];

            console.log(json);

            for (let i = 1; i < json.length; i++) {
                let data = json[i];
                let sku = data[0];
                let qty = data[1];

                if ((sku === "" || sku == undefined || sku == null) || (qty === "" || qty == undefined || qty == null)) {
                    alert(`Format issue detected for record number: ${i + 1} . Please make sure SKU and QTY are not empty.`);
                    window.location.reload();
                    return;
                }

                let orderModel = {
                    SKU: String(sku),
                    Quantity: String(qty),
                };

                itemsArray.push(orderModel);
            }

            let model = {
                OrderId,
                BranchId,
                EmployeeId,
                PatientId,
                DeviceId,
                Products: itemsArray,
            };

            callback(model);
        }
    }

    closeDialog = () => {
        this.props.importPOSOrderTemplateClear();
        this.setState({ confirmDialog: false });
        this.setState({ model: {} });
    }

    startImport = () => {
        this.props.importPOSOrderTemplateClear();
        this.props.importPOSOrderTemplate(this.state.model);
    }

    render() {
        const styles = {
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: '2px',
                left: 0,
                width: '40%',
                opacity: 0
            }
        };
        return (
            <span>
                <div className="float-L">
                    {/* <RaisedButton
                        label="Import POS Order"
                        labelPosition="before"
                        containerElement="label"
                        className="pos-button-color"
                        style={{ height: "45px" }}
                        buttonStyle={{ lineHeight: 1.2, width: "100px" }}
                        labelStyle={{ padding: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
                        fullWidth={true}
                        primary={true}
                    >
                        <input className="fileInput"
                            type="file"
                            style={styles.uploadInput}
                            onChange={(e) => this.uploadFile(e, this.callback)}
                            onClick={(e) => e.target.value = null} />
                        <ConfirmPOSOrderImportDialog
                            branchName={this.props.branchName}
                            model={this.state.model}
                            confirmDialog={this.state.confirmDialog}
                            result={this.props.importedOrdersResult}
                            closeDialog={this.closeDialog}
                            startImport={this.startImport} />
                    </RaisedButton> */}

                    <Box>
                        <input
                            className="fileInput"
                            type="file"
                            id="upload-pos-order"
                            style={styles.uploadInput}
                            onChange={(e) => this.uploadFile(e, this.callback)}
                            onClick={(e) => e.target.value = null}
                        />
                        <ConfirmPOSOrderImportDialog
                            branchName={this.props.branchName}
                            model={this.state.model}
                            confirmDialog={this.state.confirmDialog}
                            result={this.props.importedOrdersResult}
                            closeDialog={this.closeDialog}
                            startImport={this.startImport} />
                        <label htmlFor="upload-pos-order" style={{ width: '100%' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                component="span"
                                className="pos-button-color"
                                fullWidth
                                sx={{
                                    height: '45px',
                                    lineHeight: 1.2,
                                    width: '100px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                Import POS Order
                            </Button>
                        </label>
                    </Box>
                </div>
            </span>

        );
    }
}

function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        importedOrdersResult: state.entity.importedOrdersResult,
        province: state.common.store.provinceState,
        branchName: state.common.store.name || ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        importPOSOrderTemplate: (model) => dispatch(importPOSOrderTemplate(model)),
        importPOSOrderTemplateClear: () => dispatch(importPOSOrderTemplateClear()),
    }
}

export default connect(mapStatetoProps, mapDispatchToProps)(ExcelUploadPOSOrder);